"use strict";

var ubian = ubian || {};
/**
 * card buy related methods
 * @type Object
 */
ubian.cardProlongation = {};

ubian.cardProlongation.getCardType = function () {
    if (window.location.href.indexOf("emulated") >= 0) {
        return "emulated";
    }
    return "normal";
};

/**
 * update upload fields list and status (on card type change or after upload is finished)
 */
ubian.cardProlongation.getFields = function () {
    var url = $.post(ubian.routes["student_card_prolongation_documents_fields"], {}, function (
        result
    ) {
        $("#js-prolongation-documents").html(result.fields);
        $("#js-prolongation-documents input[type=file]").change(function () {
            ubian.cardProlongation.uploadDocument(this);
        });

        $("#js-prolongation-documents .js-delete-file").click(function () {
            $.post(
                ubian.routes["student_card_prolongation_documents_remove_upload"],
                { fileType: $(this).data("id") },
                function () {
                    ubian.cardProlongation.getFields();
                }
            );
        });
        ubian.cardProlongation.updateSubmitButton();
    });
};

ubian.cardProlongation.updateSubmitButton = function () {
    $(".js-btn-submit").attr("disabled", true);
    if ($(".js-document-row").length !== $(".js-delete-file").length) {
        return;
    }
    $(".js-btn-submit").removeAttr("disabled");
};

ubian.cardProlongation.uploadDocument = function (input) {
    if (!$(input).val()) {
        return;
    }

    var $formData = new FormData();
    $formData.append("file", $(input)[0].files[0]);
    $formData.append("fileType", $(input).data("fileid"));
    $.ajax(ubian.routes["student_card_prolongation_documents_upload"], {
        type: "POST",
        data: $formData,
        cache: false,
        contentType: false,
        processData: false,
        success: function (result) {
            if (result.error) {
                ubian.utils.alert(ubian.translate(result.error));
            }
            ubian.cardProlongation.getFields();
        }
    });
};

ubian.cardProlongation.submit = function () {
    $.post(
        ubian.routes["student_card_prolongation_documents_send"],
        function (result) {
            if (result && result.status=='ok') {
                var alertDlg = ubian.utils.alert(ubian.translate('Card.DiscountProlong.Success.Text'), ubian.translate('Card.DiscountProlong.Success.Title'),ubian.translate('Button.OK'), function(){
                    window.location.href = ubian.routes['card_dashboard'];
                }); 
            } else {
                ubian.utils.alert(
                    ubian.translate(result.msg)
                );
            }
        }
    );
};

ubian.cardProlongation.init = function () {
    if (!$("body").hasClass("card-prolongation-documents")) {
        return;
    }

    ubian.cardProlongation.getFields();

    $('.js-btn-submit').click(function () {
        if (!$(this).is(":disabled")) {
            ubian.cardProlongation.submit();
        }
    });
};

$(ubian.cardProlongation.init);
